import OpenAI from "openai";
import axios from "axios"

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true 
})

function base64toBlob(base64Data) {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'image/png' });
}

const createImageGPT = async (fileName, size,  prompt) => {
  try {
    const image = await openai.images.generate({
      model: "dall-e-3",
      prompt: prompt,
      n: 1,
      size: size,
      response_format:"b64_json"
    });

    const b64 = image.data[0].b64_json
    const data = b64.replace(/^data:image\/\w+;base64,/, '')
    // 브라우저에서는 Buffer함수가 사용되지 않기 때문에 변형해줘야 한다.
    const blob = base64toBlob(data)

    const file = new File([blob], fileName)
    return file
  } catch (error) {
    if (error instanceof OpenAI.APIError) {
      console.error(error.status);  // e.g. 401
      console.error(error.message); // e.g. The authentication token you passed was invalid...
      console.error(error.code);  // e.g. 'invalid_api_key'
      console.error(error.type);  // e.g. 'invalid_request_error'

      return false
    } else {
      // Non-API error
      console.log(error);
    }
    return false
  }
}

export default createImageGPT